import { CarPdfViewer } from "@app/components/PdfViewer";
import { useSearchParams } from "react-router-dom";
import { CarPdfDocument } from "@app/components/PdfDocument";
import { CarPdfPage } from "@app/components/PdfPage";
import { useUser } from "@app/pages/settings/useUser";
import { assetAllocationPages } from "@app/const/route.const";
import { usePortfolioGroupInfo } from "@app/pages/assetAllocation/usePortfolioGroupInfo";
import {
  CarPortfolioAssetColumnId,
  usePortfolioGroupVersionData,
} from "@app/pages/assetAllocation/usePortfolioGroupVersionData";
import { CarPdfTypography } from "@app/components/PdfTypography";
import { AssetClassLevel, assetClassLevelItems } from "@app/const";
import { AssetAllocationSummaryPdfChart } from "./AssetAllocationSummaryPdfChart";
import { AssetAllocationPerModulePdfTable } from "./AssetAllocationPerModulePdfTable";

export const PdfAssetAllocationSummaryReportPage = () => {
  const [searchParams] = useSearchParams();
  const { data1Id, portfolioGroupId } =
    assetAllocationPages.getPdfSummaryReportParams(searchParams);

  const groupInfo = usePortfolioGroupInfo({ portfolioGroupId });

  const { portfolioGroupVersionId, publishedVersionId } = groupInfo;

  const data = usePortfolioGroupVersionData({
    versionId: portfolioGroupVersionId,
    publishedVersionId,
    show: {
      benchmark: true,
      existing: true,
      draft: true,
      selected: false,
    },
    hideCash: true,
  });

  const user = useUser();

  const title = `Summary - ${groupInfo.title}`;
  const footer = "Asset Allocation";

  const renderPage = (level: AssetClassLevel) => (
    <CarPdfPage
      key={level}
      sectionTitle="Analyze"
      reportTitle={title}
      footer={footer}
    >
      <CarPdfTypography variant="h6" style={{ marginTop: 36 }}>
        {assetClassLevelItems.find((item) => item.value === level)?.label}
      </CarPdfTypography>

      <AssetAllocationSummaryPdfChart
        style={{ marginTop: 16 }}
        columnId={data1Id as CarPortfolioAssetColumnId}
        level={level}
        tableData={data.tableData}
      />

      <AssetAllocationPerModulePdfTable
        style={{ marginTop: 46 }}
        columnId={data1Id as CarPortfolioAssetColumnId}
        level={level}
        tableData={data.tableData}
        hideZeroValues={false}
      />
    </CarPdfPage>
  );

  return (
    <CarPdfViewer
      isLoading={user.isLoading || groupInfo.isLoading || data.isLoading}
    >
      <CarPdfDocument title={title} author={user.userFullName}>
        {renderPage(AssetClassLevel.level1)}
        {renderPage(AssetClassLevel.level2)}
        {renderPage(AssetClassLevel.level3)}
        {renderPage(AssetClassLevel.level4)}
      </CarPdfDocument>
    </CarPdfViewer>
  );
};
